import Icon from '../components/Icon.vue'

Icon.register({
  'object-ungroup': {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M64 320v26c0 3.3-2.7 6-6 6h-52c-3.3 0-6-2.7-6-6v-52c0-3.3 2.7-6 6-6h26v-192h-26c-3.3 0-6-2.7-6-6v-52c0-3.3 2.7-6 6-6h52c3.3 0 6 2.7 6 6v26h288v-26c0-3.3 2.7-6 6-6h52c3.3 0 6 2.7 6 6v52c0 3.3-2.7 6-6 6h-26v192h26c3.3 0 6 2.7 6 6v52c0 3.3-2.7 6-6 6h-52c-3.3 0-6-2.7-6-6v-26h-288zM544 256v160h26c3.3 0 6 2.7 6 6v52c0 3.3-2.7 6-6 6h-52c-3.3 0-6-2.7-6-6v-26h-288v26c0 3.3-2.7 6-6 6h-52c-3.3 0-6-2.7-6-6v-52c0-3.3 2.7-6 6-6h26v-72h136v8c0 13.3 10.7 24 24 24h64c13.3 0 24-10.7 24-24v-64c0-13.3-10.7-24-24-24h-8v-72h104v-26c0-3.3 2.7-6 6-6h52c3.3 0 6 2.7 6 6v52c0 3.3-2.7 6-6 6h-26v32z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/object-ungroup.js
// module id = 1596
// module chunks = 0